// eslint-disable-next-line no-unused-vars
import request from '@/service/http'

export function totalSearch (data) {
    return request({
        url: 'api/videoData/totalSearch',
        method: 'post',
        data,
    })
}

export function listSearchList (data) {
    return request({
        url: 'api/videoData/listSearchList',
        method: 'post',
        data,
    })
}

export function listSearchInit (data) {
    return request({
        url: 'api/videoData/listSearchInit',
        method: 'post',
        data,
    })
}

export function videoCommitToCompactor (data) {
    return request({
        url: 'api/videoData/videoCommitToCompactor',
        method: 'post',
        data,
    })
}

export function videoUrlReplace (data) {
    return request({
        url: 'api/videoData/videoUrlReplace',
        method: 'post',
        data,
    })
}

export function cancelVideoUrlReplace (data) {
    return request({
        url: 'api/videoData/cancelVideoUrlReplace',
        method: 'post',
        data,
    })
}

export function studentSearchList (data) {
    return request({
        url: 'api/videoData/studentSearchList',
        method: 'post',
        data,
    })
}

export function videobackout (data) {
    return request({
        url: 'api/videoData/videoRevocation',
        method: 'post',
        data,
    })
}

export function neglectVideoUrlReplace (data) {
    return request({
        url: 'api/videoData/neglectVideoUrlReplace',
        method: 'post',
        data,
    })
}


